import { useState, useEffect, useContext, useCallback } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ServiceContext } from "../../../contexts/ServiceContext";
import { ReactComponent as DateIcon } from "../../../icons/date.svg";
import { ReactComponent as MenuIcon } from "../../../icons/menu.svg";
import { ReactComponent as EmailsMenuIcon } from "../../../icons/email-menu.svg";
import { ReactComponent as DevicesMenuIcon } from "../../../icons/devices-menu.svg";
import { ReactComponent as UsersMenuIcon } from "../../../icons/users-menu.svg";
import { ReactComponent as CompaniesMenuIcon } from "../../../icons/company-menu.svg";
import { ReactComponent as MessagesMenuIcon } from "../../../icons/messages-menu.svg";
import { ReactComponent as PhoneNumberMenuIcon } from "../../../icons/phone-number-menu.svg";
import { ReactComponent as Error } from "../../../icons/x-circle.svg";
import { ReactComponent as Ok } from "../../../icons/check-circle.svg";
import { ReactComponent as Wait } from "../../../icons/clock-history.svg";
import { NotificationResultMetaMap } from "../../../services/notificationResultMeta";
import config from "../../../config";

function Messages () {
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const [availableCompanies, setAvailableCompanies] = useState("");
  const [availableUsers, setAvailableUsers] = useState("");
  const [availableDevices, setAvailableDevices] = useState("");
  const [emailNotifications, setAvailableEmailNotifications] = useState("");
  const [messagesNotifications, setAvailablemMssagesNotifications] = useState("");
  const [phoneCallsNotifications, setAvailablePhoneCallsNotifications] = useState("");
  const [currentPage, setCurrentPage] = useState(Number(searchParams.get("currentPage")) || 1);
  const [totalPages, setTotalPages] = useState(1);
  const [messages, setMessages] = useState([]);
  const {notificationService, infrastructureService} = useContext(ServiceContext);
  const [messagesCache, setMessagesCache] = useState({});
  let updatedIds;
  const itemsPerPage = config.uiSettings.itemsPerPage || 20;  
  
  const handlePageChange = (p) => {
    setCurrentPage(p);
    setSearchParams({ids: (updatedIds || []).join(","), currentPage: p});
  };

  function MessagesInfoDetails({sentEmailId}){
    const [sentMessages, setSentMessages] = useState(null);
    const [loadSentMessages, setLoadSentMessages] = useState(false);

    useEffect(() => { const fetchEmails = async () => {
        if (messagesCache[sentEmailId]) {
            setSentMessages(messagesCache[sentEmailId]);
            return;
        }
        try {
             setLoadSentMessages(true);
             let sentEmailDto = { notificationId: sentEmailId };
             const data = await notificationService.get("NotificationLog", sentEmailDto); 
             setSentMessages(null);
             setMessagesCache((prev) => ({ ...prev, [sentEmailId]: data }));
          } catch (error) {
             console.error("Error fetching sent messages:", error);
          }
          finally{
            setLoadSentMessages(false);
          }
        };
        fetchEmails();
    }, [sentEmailId]);

    return(
      <div>  
         {loadSentMessages && (<p style={{marginLeft:"20px"}}>Loading...</p>)}  
         {!loadSentMessages && sentMessages &&(
            <div style={{marginLeft:"1.5rem"}}>
                <label>
                     <div dangerouslySetInnerHTML={{ __html: sentMessages.actionContent}} />
                     {sentMessages.exceptionMessage && (
                        <label><svg width="24" height="24" viewBox="0 -1 24 24" fill="red">
                              <path d="M16 2H8L2 8V16L8 22H16L22 16V8L16 2Z" stroke="#000000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M12 8V12" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M12 16.0195V16" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg> <span className="span-bold">Error Description:</span> {sentMessages.exceptionMessage}
                        </label>
                     )}
                </label>
            </div>
         )}    
      </div>
    );
  }
  
  function Messages({id, executionResult, triggerType, creationDateTimeUtc}) {

      const [openExpanderCard, setOpenExpanderCard] = useState(false);
      
      useEffect(() => {
         const idsFromUrl = (searchParams.get("ids") || "").split(",").filter(Boolean).map(Number);
         setOpenExpanderCard(idsFromUrl.includes(id));
      }, [id]);
     
      const toggleCard = () => {
        const idsFromUrl = (searchParams.get("ids") || "").split(",").filter(Boolean).map(Number);       
        if (idsFromUrl.includes(id)) {
          updatedIds = idsFromUrl.filter(i => i !== id);
        } else {
           updatedIds = [...idsFromUrl, id];
          }
          setSearchParams({ ...Object.fromEntries(searchParams.entries()), ids: (updatedIds || []).join(","), currentPage: currentPage});
      };

  return (
    <div className="card-border">
      <div className="card-div" onClick={toggleCard} >
        <div className="div-inline-50">
            <label>
              <DateIcon/><span className="span-bold">Creation Date-Time</span><span>: {creationDateTimeUtc ? new Date(creationDateTimeUtc + "Z").toLocaleString() : "—"}</span>
            </label>
        </div>
        <div className="div-inline-20">
            <span className="span-bold">Trigger Type</span><span>: {triggerType}</span>
        </div>
        <div className="div-inline-20">
             {
              (() => {
                const meta = NotificationResultMetaMap.get(executionResult);
                const Icon = meta?.type === "success" ? Ok : meta?.type === "error" ? Error :  Wait;
                const color = meta?.type === "success" ? "green" : meta?.type === "error"   ? "red" : "black";
                return <label>
                            <span style={{ display: "inline-flex", alignItems: "center", gap: "2px" }}>
                              <Icon style={{ color }} width={20} height={20} viewBox="0 0 16 16" /> {meta?.label ?? "—"}
                            </span>
                          </label>;
              })()
            }
        </div>
        <div className="div-inline-3" style={{minWidth: "55px"}}>
        </div>
        <div className="div-inline-5">
          <div className="open-expander-card">
          {openExpanderCard ? "▲" : "▼"}
        </div>
        </div>
      </div>
      <div className="cerd-div">
        {openExpanderCard && (
           <div className="card-div card-border-text">
              <div className="div-inline-100">
                <MessagesInfoDetails key={id} sentEmailId={id}/>
              </div>
           </div>
        )}
      </div>
    </div>
  );
  }  
  
  const loadMessages = useCallback(async () => {
    try {
         setLoading(true);
         let getEmails = {
            fromIndex: (currentPage - 1) * itemsPerPage,
            itemsCount: itemsPerPage,
            actionType: 2
        };
        const data = await notificationService.get("NotificationLogs", getEmails); 
        setMessages(data.items);
        setTotalPages(Math.ceil(data.totalItemsCount / itemsPerPage));
    } catch (error) {
         console.error("Error fetching messages:", error);
    } finally {
         setLoading(false);
    }
  }, [itemsPerPage, currentPage, notificationService]);
  
  useEffect(() => {
      loadMessages();
  }, [loadMessages]);

  useEffect(() => {
    const newCurrentPage = Number(searchParams.get("currentPage")) || 1;
    setCurrentPage(newCurrentPage);
  }, [searchParams]);
  
  const loadStatisticSummary = useCallback(async () => {
    try {
      setLoading(true);
       const data = await infrastructureService.get("Statistic"); 
       setAvailableCompanies(data.availableCompanies);
       setAvailableDevices(data.availableDevices);
       setAvailableUsers(data.availableUsers);
       setAvailableEmailNotifications(data.emailNotifications);
       setAvailablemMssagesNotifications(data.smsNotifications);
       setAvailablePhoneCallsNotifications(data.phoneCallsNotifications);
    } catch (error) {
       console.error("Error fetching statistic summary:", error);
    } finally {
      setLoading(false);
    }
  }, [infrastructureService]);

  useEffect(() => {
     loadStatisticSummary()
  }, [loadStatisticSummary]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 600) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    };
    
    handleResize();
    
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getPages = () => {
    const pages = [];
    const delta = 1; 
  
    for (let i = 1; i <= Math.min(2, totalPages); i++) {
      pages.push(i);
    }
  
    const start = Math.max(currentPage - delta, 3);
    const end = Math.min(currentPage + delta, totalPages - 2);

    if (start > 3) pages.push("left-ellipsis");

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < totalPages - 2) pages.push("right-ellipsis");

    if (totalPages > 3) {
      for (let i = Math.max(totalPages - 1, end + 1); i <= totalPages; i++) {
        pages.push(i);
      }
    }

    return [...new Set(pages)]; 
  }

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <div className="div-menu">
        <div onClick={() => setOpen(true)} className="menu-button">
          <label><svg width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 
                                         0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
          </svg></label>
        </div>
        {open && (
          <div className="modal">
             <div className="modal-content">
               <div className="col-span-12 h-full rounded-2xl bg-white/70 p-4 shadow-sm ring-1 ring-gray-100 md:col-span-3 lg:col-span-2 modal-content-div">
                <div className="close-modal" onClick={() => setOpen(false)}>
                  <MenuIcon/>
                </div>
                <div className="space-y-6">
                  <div>
                      <p className="px-2 text-sm font-semibold text-gray-600">Overview</p>
                      <div className="mt-2 space-y-1">
                         <Link className="link-item" to="/">
                           <label className="link-lab"> 
                              <CompaniesMenuIcon/> Companies
                              <label className="label-float-end">{availableCompanies}</label>
                           </label>
                         </Link>
                         <Link className="link-item" to="/users">
                           <label className="link-lab">
                              <UsersMenuIcon/> Users
                              <label className="label-float-end">{availableUsers}</label>
                           </label>
                         </Link>
                         <Link className="link-item" to="/devices">
                           <label className="link-lab">
                               <DevicesMenuIcon/> Devices
                               <label className="label-float-end">{availableDevices}</label>
                           </label>
                         </Link>
                      </div>
                      <hr/>
                  </div>
                  
                   <div className="pt-2">
                        <p className="px-2 text-sm font-semibold text-gray-600">Notifications</p>
                        <div className="mt-2 space-y-1">
                         <Link className="link-item" to="/emails">
                           <label className="link-lab">
                              <EmailsMenuIcon/> Emails
                               <label className="label-float-end">{emailNotifications}</label>
                           </label>
                         </Link>
                         <Link className="link-item-selected" to="/messages">
                           <label className="link-lab">
                              <MessagesMenuIcon/> Messages
                              <label className="label-float-end">{messagesNotifications}</label>
                           </label>
                         </Link>
                         <Link className="link-item" to="/phoneCalls">
                           <label className="link-lab">
                              <PhoneNumberMenuIcon/> Phone Calls
                              <label className="label-float-end">{phoneCallsNotifications}</label>
                           </label>
                         </Link>
                        </div>
                        <hr/>
                    </div>
                    
                  <div className="mx-2 h-px bg-gray-200"/></div>
                </div>
             </div>
          </div>
        )}
      </div>
       <div className='companies'>
                
          <div className="pagination-div pagination-div-margin">
                <nav aria-label="pagination">
                   <ul className="pagination">
                    <li>
                      <button disabled={currentPage === 1} onClick={() => handlePageChange(1)}
                          style={{padding: "5px 10px", borderRadius: "15px", border: "1px solid #ccc",
                                  color: "#333", fontWeight: "normal", backgroundColor: currentPage === 1 ? "#e6e6e6ff" : "white" }}>
                         &laquo;
                      </button>
                    </li>
                    {getPages().map((page, index) => page === "left-ellipsis" || page === "right-ellipsis" ? (
                        <li key={index}>…</li>) : (<li key={index}>
                          <button onClick={() => handlePageChange(page)}
                            style={{ margin: "0", padding: "5px 10px", borderRadius: "15px", border: "1px solid #ccc",
                                     backgroundColor: currentPage === page ? "#333" : "white", color: currentPage === page ? "white" : "#333", 
                                     fontWeight: currentPage === page ? "bold" : "normal", cursor: "pointer"}}>
                            {page}
                          </button>
                        </li>
                     ))}
                     <li>
                      <button disabled={currentPage === totalPages} onClick={() => handlePageChange(totalPages)}
                           style={{padding: "5px 10px", borderRadius: "15px", border: "1px solid #ccc",
                                   color: "#333", fontWeight: "normal", backgroundColor: currentPage === totalPages ? "#e6e6e6ff" : "white" }}>
                        &raquo;
                      </button>
                    </li>
                   </ul>
                </nav>
               </div>

         <div className="card-list">
            {messages != null && messages.length > 0 ? (messages.map((email) => (
              <Messages key={email.id} id={email.id} executionResult={email.executionResult} triggerType={email.triggerType} creationDateTimeUtc={email.creationDateTimeUtc}/>))) : (
              <p>No messages available.</p>
            )}
         </div>

       </div>
    </div>
  );
}

export default Messages;